// src/components/auth/ProtectedRoute.jsx
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { initializeAuth } from '../../redux/features/authSlice';

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { user, isInitialized } = useSelector(state => state.auth);

    useEffect(() => {
        if (!isInitialized) {
            dispatch(initializeAuth());
        }
    }, [dispatch, isInitialized]);

    useEffect(() => {
        if (isInitialized && !user) {
            // Redirect to login page but save the attempted URL
            navigate('/admin/login', {
                replace: true,
                state: { from: location.pathname }
            });
        }
    }, [user, isInitialized, navigate, location]);

    if (!isInitialized) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
            </div>
        );
    }

    if (!user) {
        return null;
    }

    return children;
};

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired
};

export default ProtectedRoute;
